// src/index.js
import('./bootstrap');
